import { LearnMoreLink, SectionDemoLink } from '../CTAButtons/CTAButtons';
import MockThumb from '../MockThumb/MockThumb';
import { routes } from '../../config/links';
import { mockAssets } from '../../config/mockAssets';
import styles from './ShowcaseMockups.module.css';

interface ShowcaseMockupsProps {
  showLearnMore?: boolean;
}

function ShowcaseMockups({ showLearnMore = true }: ShowcaseMockupsProps) {
  return (
    <section id="technology" className={`section ${styles.section}`} aria-labelledby="technology-heading">
      <div className="container">
        <span className="sectionLabel">Technology</span>
        <h2 id="technology-heading" className="sectionTitle">
          The platform behind every order
        </h2>
        <p className="sectionSubtitle">
          ONI connects the fan ordering experience with the tools stadium teams use to fulfill, track, and optimize every order.
        </p>

        <div className={styles.grid}>
          <article className={styles.panel}>
            <div className={styles.label}>Customer app</div>
            <div className={styles.phoneFrame}>
              <div className={styles.phoneTop}>Browse · Cart · Orders</div>
              <div className={styles.menuItem}>
                <MockThumb src={mockAssets.foodBurger} alt="Classic Burger Combo" />
                <div>
                  <strong>Classic Burger Combo</strong>
                  <p>$14.50 · Add to cart</p>
                </div>
              </div>
              <div className={styles.menuItem}>
                <MockThumb src={mockAssets.foodLemonade} alt="Stadium Lemonade" />
                <div>
                  <strong>Stadium Lemonade</strong>
                  <p>$6.00 · Customize</p>
                </div>
              </div>
              <div className={styles.cartBar}>View cart · 2 items · $20.50</div>
            </div>
          </article>

          <article className={styles.panel}>
            <div className={styles.label}>Admin dashboard</div>
            <div className={styles.desktopFrame}>
              <div className={styles.desktopHeader}>
                <span>Dashboard</span>
                <span>Analytics</span>
                <span>Orders</span>
              </div>
              <div className={styles.chartArea}>
                <div className={styles.bar} style={{ height: '45%' }} />
                <div className={styles.bar} style={{ height: '70%' }} />
                <div className={styles.bar} style={{ height: '55%' }} />
                <div className={styles.bar} style={{ height: '85%' }} />
                <div className={styles.bar} style={{ height: '62%' }} />
              </div>
              <div className={styles.table}>
                <div><span>Vendor</span><strong>Orders</strong><strong>Revenue</strong></div>
                <div><span>Stadium Grill</span><strong>42</strong><strong>$1.8k</strong></div>
                <div><span>Bay Bites</span><strong>31</strong><strong>$1.1k</strong></div>
              </div>
            </div>
          </article>
        </div>
        {showLearnMore && (
          <div className={styles.links}>
            <LearnMoreLink to={routes.technology} label="Explore the platform →" />
            <SectionDemoLink />
          </div>
        )}
      </div>
    </section>
  );
}

export default ShowcaseMockups;
